import { render, staticRenderFns } from "./tabFlip.vue?vue&type=template&id=01de345b&"
import script from "./tabFlip.vue?vue&type=script&lang=js&"
export * from "./tabFlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports